// フッターのブランドリストスライダー
$(function () {
  const mvSwiper = new Swiper('.js-brand-swiper', {
    slidesPerView: 3,
    spaceBetween: 9,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centerdSlides: true
      }
    },
    on: {
      init: function () {
        updateProgressBar(this.progress);
      },
      slideChange: function () {
        updateProgressBar(this.progress);
      },
    },
  })
  function updateProgressBar(progress) {
    var progressBar = document.querySelector('.js-brand-swiper-progressbar .in-bar');
    progressBar.style.width = progress * 100 + '%';
  }
})

// 目次自動変更
$(function () {
  const tocList = '.js-toc-nav';
  const tocSection = '.js-toc-section';
  const headerEle = '.js-header'
  const headerHeight = $(headerEle).height();
  // console.log(headerHeight)

  let isScrolling = false;

  $(tocSection).each(function (index, element) {
    ScrollTrigger.create({
      trigger: element, // この要素をトリガーとする
      start: 'top 200',
      end: 'bottom 200',
      onEnter: () => !isScrolling && toggleTocList(element),
      onEnterBack: () => !isScrolling && toggleTocList(element)
    });
  });
  function toggleTocList(element) {
    const thisId = $(element).attr('id');
    $(tocList).find('.is-active').removeClass('is-active');
    $(tocList).find(`[href="#${thisId}"]`).addClass('is-active');
    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      const activeElement = $(tocList).find('.is-active');
      const tocListOffsetLeft = $(tocList).offset().left;
      const activeElementOffsetLeft = activeElement.offset().left;
      const activeScrollX = activeElementOffsetLeft - tocListOffsetLeft + $(tocList).scrollLeft() - 20;

      gsap.to(tocList, {
        scrollLeft: activeScrollX
      });
    }
  }
  $(window).scroll(function () {
    const scrollPosition = $(window).scrollTop();
    if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
      if (scrollPosition > headerHeight + 200) {
        const thisHeaderHeight = $('[x-ref=spScrolledNav]').height();
        // const adjustHeaderHeight = $('[x-ref=spScrolledNav]').height() + $('[x-ref=spCatNav]').height();
        gsap.to(tocList, {
          top: thisHeaderHeight
        })
      } else {
        gsap.to(tocList, {
          top: 0
        })
      }
    }
  })
  // 目次のリンクがクリックされたときの動作
  $('.js-toc-anker').on('click', function (e) {
    e.preventDefault(); // デフォルトの動作を停止
    isScrolling = true

    var targetId = $(this).attr('href');
    var targetPosition = $(targetId).offset().top - headerHeight; // ヘッダーの高さを考慮したスクロール位置を計算

    $('html, body').animate({ scrollTop: targetPosition }, 300, 'swing', function () {
      // スクロール完了後のコールバック（必要に応じて）
      isScrolling = false
    });
  });
})